import { DocumentPreparationState, DocumentPreparationAction, DOCUMENT_PREPARATION_ACTIONS } from './types';

const initialState: DocumentPreparationState = {
  isCreatingReports: false,
  isLoading: false,
  isInit: false,
  isDisabledGenerateBtn: true,
  data: [],
  pagination: {
    page: 1,
    totalPages: 0,
  },
  error: null,
};

export const documentPreparationReducer = (
  state: DocumentPreparationState = initialState,
  action: DocumentPreparationAction
): DocumentPreparationState => {
  switch (action.type) {
    case DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION:
      return {
        ...state,
        isCreatingReports: true,
        isLoading: true,
        error: null,
        pagination: { ...state.pagination, page: 1 },
      };

    case DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION_FAILURE:
      return {
        ...state,
        isCreatingReports: false,
        isLoading: false,
        error: action.payload,
      };

    case DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES:
      return {
        ...state,
        error: null,
      };

    case DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES_SUCCESS:
      return {
        ...state,
        data: state.pagination.page === 1 ? action.payload.data : state.data,
        isLoading: state.pagination.page === 1 ? false : state.isLoading,
        pagination: { ...state.pagination, totalPages: action.payload.totalPages },
      };

    case DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES_FAILURE:
      return {
        ...state,
        isCreatingReports: false,
        isLoading: false,
        error: action.payload,
      };

    case DOCUMENT_PREPARATION_ACTIONS.SET_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, page: action.payload },
      };

    case DOCUMENT_PREPARATION_ACTIONS.LOAD_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, page: action.payload },
        isLoading: true,
        error: null,
      };
    case DOCUMENT_PREPARATION_ACTIONS.LOAD_PAGE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        pagination: { ...state.pagination, totalPages: action.payload.totalPages },
        isLoading: false,
        error: null,
      };

    case DOCUMENT_PREPARATION_ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case DOCUMENT_PREPARATION_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case DOCUMENT_PREPARATION_ACTIONS.START_MONITORING:
      return {
        ...state,
        isInit: true,
        isCreatingReports: true,
      };

    case DOCUMENT_PREPARATION_ACTIONS.STOP_MONITORING:
      return {
        ...state,
        isCreatingReports: false,
      };

    case DOCUMENT_PREPARATION_ACTIONS.UPDATE_GENERATE_BTN_STATE:
      return {
        ...state,
        isDisabledGenerateBtn: action.payload,
      };

    default:
      return state;
  }
};
